import L from 'leaflet'

const WindyPlugin = {
  install(Vue, options) {
    Vue.prototype.$initWindyMap = function (elementId, windyOptions, WeatherComponent) {
      const defaultOptions = {
        key: '5xFhdwFu5PtGrivNp2y4p4CjejGzX7Sc', // REPLACE WITH YOUR KEY !!!
        verbose: false,
        lat: -25.597576285627483,
        lon: -54.48808204999569,
        zoom: 10,
        lang: 'pt',
      }

      const finalOptions = { ...defaultOptions, ...windyOptions }

      const initWindy = () => {
        const script = document.createElement('script')
        script.src = 'https://api.windy.com/assets/map-forecast/libBoot.js'
        script.async = true
        script.onload = () => {
          windyInit(finalOptions, (windyAPI) => {
            const { map } = windyAPI

            const controlDiv = L.DomUtil.create('div', 'leaflet-control')
            const WeatherControlComponent = Vue.extend(WeatherComponent)
            const instance = new WeatherControlComponent()
            instance.$mount()
            controlDiv.appendChild(instance.$el)

            const customControl = L.Control.extend({
              options: {
                position: 'topleft',
              },
              onAdd: function () {
                return controlDiv
              },
            })

            map.addControl(new customControl())
          })
        }
        document.head.appendChild(script)
      }

      const checkElement = setInterval(() => {
        if (document.getElementById(elementId)) {
          clearInterval(checkElement)
          initWindy()
        }
      }, 100)
    }
  },
}

export default WindyPlugin
